module.exports = __webpack_public_path__ + "static/img/snip3down.55c41c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/hero/snip3down.png
// module id = Fr/v
// module chunks = 35